import type {
  AutoplayOptionsType,
  WheelGesturesPluginType,
} from "types/vendor/embla-carousel";

export function getAutoplayPlugin(options?: AutoplayOptionsType) {
  if (!window.EmblaCarouselAutoplay) {
    console.error(
      "EmblaCarouselAutoplay is not on window. Did you load the UMD script?",
    );
    return;
  }
  return window.EmblaCarouselAutoplay(options);
}

export function getWheelGesturesPlugin(
  options?: WheelGesturesPluginType["options"],
) {
  if (!window.EmblaCarouselWheelGestures) {
    console.error(
      "EmblaCarouselWheelGestures is not on window. Did you load the UMD script?",
    );
    return;
  }
  return window.EmblaCarouselWheelGestures(options);
}
